import StickyNav from "legacy/sticky_nav";

window.addEventListener("DOMContentLoaded", () => {
  new StickyNav();
});
